import { render } from "./SectionPickerPopup.vue?vue&type=template&id=520437c1&scoped=true"
import script from "./SectionPickerPopup.vue?vue&type=script&lang=js"
export * from "./SectionPickerPopup.vue?vue&type=script&lang=js"

import "./SectionPickerPopup.vue?vue&type=style&index=0&id=520437c1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520437c1"]])

export default __exports__